import * as React from 'react';

const Calendar24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.25 1a.75.75 0 0 1 .75.75v1.277h8V1.75a.75.75 0 0 1 1.5 0v1.277h1.75A2.75 2.75 0 0 1 22 5.777V19.25A2.75 2.75 0 0 1 19.25 22H4.75A2.75 2.75 0 0 1 2 19.25V5.777a2.75 2.75 0 0 1 2.75-2.75H6.5V1.75A.75.75 0 0 1 7.25 1M6.5 4.527H4.75c-.69 0-1.25.56-1.25 1.25V9h17V5.777c0-.69-.56-1.25-1.25-1.25H17.5V5.75a.75.75 0 0 1-1.5 0V4.527H8V5.75a.75.75 0 0 1-1.5 0zm14 5.974h-17v8.75c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25z"
  }
));
Calendar24.Size = 24;
Calendar24.Title = "Calendar";

export { Calendar24 as default };
